import posthog from "posthog-js"

export const useAnalytics = () => {
  const isLocalBuild = process.env.NODE_ENV === "development"

  if (isLocalBuild) {
    return {
      track: () => {},
      reset: () => {},
      identify: () => {},
    }
  }

  return {
    track: (event: string, properties?: Record<string, any>) => {
      posthog.capture(event, properties)
    },
    /**
     * This is important if your users are sharing a computer,
     * as otherwise all of those users are grouped together into a single user
     * due to shared cookies between sessions. We strongly recommend you call reset
     * on logout even if you don't expect users to share a computer.
     */
    reset: () => {
      posthog.reset()
    },
    identify: (id: string, properties?: Record<string, any>) => {
      posthog.identify(id, properties)
    },
  }
}
